import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-vis-tooltip": "" }

import { Tooltip, TooltipConfigInterface } from '@unovis/ts'
import { onMounted, onUnmounted, computed, ref, watch, nextTick, inject } from 'vue'
import { arePropsEqual, useForwardProps } from '../../utils/props'
import { tooltipAccessorKey } from '../../utils/context'


export const VisTooltipSelectors = Tooltip.selectors

type Props = TooltipConfigInterface

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    components: {},
    container: {},
    horizontalPlacement: {},
    horizontalShift: {},
    verticalPlacement: {},
    verticalShift: {},
    triggers: {},
    attributes: {},
    data: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

// !!! This code was automatically generated. You should not change it !!!
const accessor = inject(tooltipAccessorKey)

// data and required props 



// config
const config = useForwardProps(props)

// component declaration
const component = ref<Tooltip>()


onMounted(() => {
  nextTick(() => {
    component.value = new Tooltip(config.value)
    
    accessor.update(component.value)
  })
})

onUnmounted(() => {
  component.value?.destroy()
  accessor.destroy()
})

watch(config, (curr, prev) => {
  if (!arePropsEqual(curr, prev)) {
    component.value?.setConfig(config.value)
  }
})


__expose({
  component
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})